import { triangulateToUnique as u } from "@allmaps/triangulate";
import { computeDistortionFromPartialDerivatives as c } from "@allmaps/transform";
import { mixPoints as p, mixNumbers as l, getPropertyFromCacheOrComputation as P, geometryToDiameter as d, getPropertyFromDoubleCacheOrComputation as n } from "@allmaps/stdlib";
import h from "./WarpedMap.js";
const T = 80, g = 10;
function m() {
  return {};
}
function j() {
  return (s, t, e) => new v(s, t, e);
}
class v extends h {
  resourceTrianglePoints = [];
  resourceUniquePoints = [];
  trianglePointsUniquePointsIndex = [];
  triangulationByBestScaleFactor = /* @__PURE__ */ new Map();
  triangulateErrorCount = 0;
  projectedGeoPreviousTrianglePoints = [];
  projectedGeoTrianglePoints = [];
  projectedGeoUniquePoints = [];
  projectedGeoUniquePointsByBestScaleFactorAndTransformationType = /* @__PURE__ */ new Map();
  projectedGeoUniquePointsPartialDerivativeX = [];
  projectedGeoUniquePointsPartialDerivativeY = [];
  projectedGeoUniquePointsPartialDerivativeXByBestScaleFactorAndTransformationType = /* @__PURE__ */ new Map();
  projectedGeoUniquePointsPartialDerivativeYByBestScaleFactorAndTransformationType = /* @__PURE__ */ new Map();
  previousTrianglePointsDistortion = [];
  trianglePointsDistortion = [];
  uniquePointsDistortion = [];
  /**
   * Creates an instance of a TriangulatedWarpedMap.
   *
   * @constructor
   * @param {string} mapId - ID of the map
   * @param {GeoreferencedMap} georeferencedMap - Georeferenced map used to construct the WarpedMap
   * @param {WarpedMapOptions} [options] - Options
   */
  constructor(t, e, i) {
    i = {
      ...m(),
      ...i
    }, super(t, e, i);
  }
  /**
   * Update the resourceMask.
   *
   * @param {Ring} resourceMask
   */
  setResourceMask(t) {
    super.setResourceMask(t), this.triangulationByBestScaleFactor = /* @__PURE__ */ new Map(), this.projectedGeoUniquePointsByBestScaleFactorAndTransformationType = /* @__PURE__ */ new Map(), this.projectedGeoUniquePointsPartialDerivativeXByBestScaleFactorAndTransformationType = /* @__PURE__ */ new Map(), this.projectedGeoUniquePointsPartialDerivativeYByBestScaleFactorAndTransformationType = /* @__PURE__ */ new Map(), this.updateTriangulation();
  }
  /**
   * Set the bestScaleFactor for the current viewport
   *
   * @param {number} scaleFactor - scale factor
   * @returns {boolean}
   */
  setCurrentBestScaleFactor(t) {
    const e = super.setCurrentBestScaleFactor(t);
    return e && this.updateTriangulation(!0), e;
  }
  /**
   * Reset the previous points and values.
   */
  resetPrevious() {
    super.resetPrevious(), this.projectedGeoPreviousTrianglePoints = this.projectedGeoTrianglePoints, this.previousTrianglePointsDistortion = this.trianglePointsDistortion;
  }
  /**
   * Mix the previous and new points and values.
   *
   * @param {number} t
   */
  mixPreviousAndNew(t) {
    super.mixPreviousAndNew(t), this.projectedGeoPreviousTrianglePoints = this.projectedGeoTrianglePoints.map((e, i) => p(
      e,
      this.projectedGeoPreviousTrianglePoints[i],
      t
    )), this.previousTrianglePointsDistortion = this.trianglePointsDistortion.map(
      (e, i) => l(
        e,
        this.previousTrianglePointsDistortion[i],
        t
      )
    );
  }
  /**
   * Update the triangulation of the resourceMask, at the current bestScaleFactor. Use cache if available.
   *
   * @param {boolean} [previousIsNew] - whether the previous and new triangulation are the same - true by default, false during a transformation transition
   */
  updateTriangulation(t = !1) {
    if (!this.currentBestScaleFactor)
      return;
    const { trianglePointsUniquePointsIndex: e, resourceUniquePoints: i } = P(
      this.triangulationByBestScaleFactor,
      this.currentBestScaleFactor,
      () => {
        const r = d(this.resourceMask) * this.currentBestScaleFactor / T;
        try {
          const { uniquePointsIndexTriangles: o, uniquePoints: a } = u(this.resourceMask, r);
          return {
            trianglePointsUniquePointsIndex: o.flat(),
            resourceUniquePoints: a
          };
        } catch (o) {
          return this.triangulateErrorCount++, this.triangulateErrorCount <= g && (console.error(
            `Error computing triangulation for map ${this.mapId}.`,
            `Fix this map with Allmaps Editor: https://editor.allmaps.org/#/collection?url=${this.parsedImage?.uri}/info.json`
          ), this.triangulateErrorCount === 1 && console.error(o)), {
            trianglePointsUniquePointsIndex: this.trianglePointsUniquePointsIndex,
            resourceUniquePoints: this.resourceUniquePoints
          };
        }
      }
    );
    this.resourceTrianglePoints = e.map(
      (r) => i[r]
    ), this.resourceUniquePoints = i, this.trianglePointsUniquePointsIndex = e, this.updateProjectedGeoTrianglePoints(t);
  }
  /**
   * Update the (previous and new) points of the triangulated resourceMask, at the current bestScaleFactor, in projectedGeo coordinates. Use cache if available.
   *
   * @param {boolean} [previousIsNew=false]
   */
  updateProjectedGeoTrianglePoints(t = !1) {
    this.currentBestScaleFactor && (this.projectedGeoUniquePoints = n(
      this.projectedGeoUniquePointsByBestScaleFactorAndTransformationType,
      this.currentBestScaleFactor,
      this.transformationType,
      () => this.resourceUniquePoints.map(
        (e) => this.projectedTransformer.transformToGeo(e)
      )
    ), this.projectedGeoTrianglePoints = this.trianglePointsUniquePointsIndex.map(
      (e) => this.projectedGeoUniquePoints[e]
    ), (t || !this.projectedGeoPreviousTrianglePoints.length) && (this.projectedGeoPreviousTrianglePoints = this.projectedGeoTrianglePoints), this.updateTrianglePointsDistortion(t));
  }
  /**
   * Update the (previous and new) distortion at the points of the triangulated resourceMask. Use cache if available.
   *
   * @param {boolean} [previousIsNew=false]
   */
  updateTrianglePointsDistortion(t = !1) {
    this.currentBestScaleFactor && (this.distortionMeasure && (this.projectedGeoUniquePointsPartialDerivativeX = n(
      this.projectedGeoUniquePointsPartialDerivativeXByBestScaleFactorAndTransformationType,
      this.currentBestScaleFactor,
      this.transformationType,
      () => this.resourceUniquePoints.map(
        (e) => this.projectedTransformer.transformToGeo(e, {
          evaluationType: "partialDerivativeX"
        })
      )
    ), this.projectedGeoUniquePointsPartialDerivativeY = n(
      this.projectedGeoUniquePointsPartialDerivativeYByBestScaleFactorAndTransformationType,
      this.currentBestScaleFactor,
      this.transformationType,
      () => this.resourceUniquePoints.map(
        (e) => this.projectedTransformer.transformToGeo(e, {
          evaluationType: "partialDerivativeY"
        })
      )
    )), this.uniquePointsDistortion = this.projectedGeoUniquePoints.map(
      (e, i) => c(
        this.projectedGeoUniquePointsPartialDerivativeX[i],
        this.projectedGeoUniquePointsPartialDerivativeY[i],
        this.distortionMeasure,
        this.getReferenceScale()
      )
    ), this.trianglePointsDistortion = this.trianglePointsUniquePointsIndex.map(
      (e) => this.uniquePointsDistortion[e]
    ), (t || !this.previousTrianglePointsDistortion.length) && (this.previousTrianglePointsDistortion = this.trianglePointsDistortion));
  }
  updateTransformerProperties(t = !0) {
    super.updateTransformerProperties(t), this.updateProjectedGeoTrianglePoints(!1);
  }
  updateDistortionProperties() {
    super.updateDistortionProperties(), this.updateTrianglePointsDistortion(!1);
  }
}
export {
  j as createTriangulatedWarpedMapFactory,
  v as default
};
//# sourceMappingURL=TriangulatedWarpedMap.js.map
